import { createContext, useReducer, useContext, Dispatch, FC } from 'react';
import { TOGGLE_MODAL } from 'state/actionTypes/modalActionTypes';
import { ModalAction, ModalReducer, ModalState, ModalType } from './types';

type ModalContext = {
  modal: ModalState;
  dispatch: Dispatch<ModalAction>;
};
type UseModalContext = () => ModalContext;

const ModalContext = createContext({} as ModalContext);

const INITIAL_STATE: ModalState = {
  modalType: ModalType.NO_MODAL,
  modalProps: {} as ModalState['modalProps'],
};

// Reducer
const modalReducer: ModalReducer = (state, action) => {
  const { type } = action;

  switch (type) {
    case TOGGLE_MODAL: {
      const close = !action.payload.action;

      if (close) return { ...state, modalType: ModalType.NO_MODAL };

      return {
        modalType: action.payload.data.modalType,
        modalProps: action.payload.data.modalProps,
      } as ModalState;
    }

    default:
      return state;
  }
};

export const ModalProvider: FC = (props) => {
  const [modal, dispatch] = useReducer(modalReducer, INITIAL_STATE);

  const modalData = { modal, dispatch };

  return <ModalContext.Provider value={modalData} {...props} />;
};

export const useModalContext: UseModalContext = () => useContext(ModalContext);
